import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  moveKanbanTask(request: Boundaries["moveKanbanTask"]["request"]): void;
}

function useMoveKanbanTask(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isMoveKanbanTaskRequestPending),
    isRequestSuccess: useSelector(selector.isMoveKanbanTaskRequestSuccess),
    isRequestFailure: useSelector(selector.isMoveKanbanTaskRequestFailure),
    moveKanbanTask: core.moveKanbanTask,
  };
}

export { useMoveKanbanTask };
